<template>
  <div>
    <van-divider :style="{ borderColor: '#888888', padding: '0 120px', color: '#1baeae' }">商品评论</van-divider>
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getComment"
    >
      <div class="item" v-bind:class="{ childClass: item.parent_id>0 }" v-for="item in list" :key="item.id">
        <div class="title">
          <van-image class="avatar" round width="30px" height="30px" :src="item.avatar" />
          <div class="name">{{item.user_nickname}}</div>
          <div class="date">{{item.timeStr}}</div>
        </div>

        <div class="content"><span v-if="item.parent_id>0">回复：</span>{{item.content}}</div>
        <div v-if="item.img">
          <img :src="GLOBAL.IMG + item.img" style="width:30%" />
        </div>
        <div style="text-align:right" v-if="item.parent_id==0">
          <van-rate v-model="item.score" />
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import Vue from "vue";
import { Rate } from "vant";
import { Divider } from "vant";

Vue.use(Divider);
Vue.use(Rate);
export default {
  name: "comment",
  props: ["id", "module", "token"],

  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      cPage: 1
    };
  },
  methods: {
    getComment() {
      this.$http
        .get(this.GLOBAL.API + "/s_shop/goods/comment", {
          params: { id: this.id, module: this.module, page: this.cPage },
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          this.loading = false;
          if (this.cPage >= data.data.last_page) {
            this.finished = true;
          } else {
            this.cPage++;
          }
          if (data.code == 1) {
            this.list = this.list.concat(data.data.data); //= data.data.data;
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.list{
    background-color: #fff;
}
.item {
  padding: 10px;
  border-bottom: 1px solid #f6f6f6;
  .title {
    display: flex;
    .date {
      flex-grow: 1;
      text-align: right;
    }
    .name {
      line-height: 30px;
      padding-left: 20px;
    }
  }
}
.childClass{
    padding-left:50px;
}
</style>